
// Function to get the content of a meta tag by its name attribute
const getMetaValueByName = (name) => {
  const metaTag = document.querySelector(`meta[name="${name}"]`);
  return metaTag ? metaTag.getAttribute('content') : null;
};

export default function CSRFInput() {

  const token = getMetaValueByName("_csrf");
  //const headerName = csrf?.headerName || getMetaValueByName("_csrf_header");
  const parameterName = getMetaValueByName("_csrf_param_name");

  return (
    <input type="hidden"
           name={parameterName}
           value={token}/>
  );
}

export function csrfToken() {
    return {
      token : getMetaValueByName("_csrf"),
      parameterName: getMetaValueByName("_csrf_param_name"),
      headerName: getMetaValueByName("_csrf_header_name"),
    }
}
